import { useThemeStore } from "../stores/theme.store.js";
import { blockTintFromDiff, type BlockTint } from "./task-colors.js";

export interface BlockStyleOptions {
  /** Per-kind softening amounts (tasks lighter, events more saturated). */
  tint: BlockTint;
  /** Whether single-color blocks get a slight gradient sheen. */
  gradient: boolean;
}

/** Block-rendering options derived from the active theme. Pass `tint`/`gradient`
 *  to {@link washStyle}. (Folded out of settings into the theme record.) */
export function useBlockStyle(): BlockStyleOptions {
  const diff = useThemeStore((s) => s.config.blockTintDiff);
  const gradient = useThemeStore((s) => s.config.blockGradient);
  return { tint: blockTintFromDiff(diff), gradient };
}
